import { googleService } from "components/GoogleMapsAutoComplete";
import { farehelper } from "../../config/FareCalculator";
export const DEFAULT_PRICE = 20000;
export const DEFAULT_DIST = 50000;
export const DEFAULT_EXON = 1000;
export const formatDate = (date = new Date()) => {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;

  let today = year + "-" + month + "-" + day;
  return today;
};

export const formatTime = (date = new Date()) => {
  let hours = date.getUTCHours() + 1;
  if (hours / 10 >= 1) {
    return hours + ":" + date.getMinutes();
  }
  return "0" + hours + ":" + date.getMinutes();
};

export const calculeDistance = async (startLoc, destLoc) => {
  try {
    if (!googleService.distanceMetrix) {
      googleService.distanceMetrix = new googleService.current.DistanceMatrixService();
    }

    const responses = await googleService.distanceMetrix.getDistanceMatrix(
      {
        origins: [startLoc.coords, startLoc.description],
        destinations: [destLoc.coords, destLoc.description],
        travelMode: "DRIVING",
      },
      (response, status) => ({
        response,
        status,
      })
    );
    return {
      distance: responses.rows[0].elements[0].distance,
      duration: responses.rows[0].elements[0].duration,
    };
  } catch (error) {
    return null;
  }
};

export const calculePrice = (distance, voiture) => {
  if (distance) {
    return farehelper(distance.distance.value, distance.duration.value, voiture);
  }

  return null;
};
